module.exports = __webpack_public_path__ + "img/autorizar (3) 1.9892f32b.png";